import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/th/compare/cargowise-alternative")({
  beforeLoad: () => {
    throw redirect({ to: "/th/compare/cargonova-vs-cargowise", replace: true });
  },
});
